module.exports = __webpack_public_path__ + "static/media/physio6_sqr.2f398673.jpg";